/* eslint-disable camelcase */
import $ from 'jquery';
import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import {
  getTitlePreview,
  getDescPreview,
  getMoreTitleHint,
  getMoreDescHint,
} from '@bingads-webui-campaign/summary-grid-helper';
import { AdPreviewColumn as AdPreviewColumnConfig } from '@bingads-webui-campaign/ads-data';
import { isXandrCampaign } from '@bingads-webui-campaign-react/constants';
import adTemplate from './ad-preview.pug';
import { getAdEditorInitializer, getAdEditorInitializerWebpack } from '../../../index';

const appConfig = globalContext.require('component/config/index');
const adDisplayUrlService = globalContext.require('campaignui/feature/crud-ad/service/displayUrl');
const { combineText } = globalContext.require('campaignui/feature/crud-ad/viewmodel/adsPreview/expandedTextAd');

const responsiveAdThumbnailWidth = 114;
const responsiveAdThumbnailHeight = 60;
const resizeQueryString = `&w=${responsiveAdThumbnailWidth}&h=${responsiveAdThumbnailHeight}`;
const isImpressionTrackingUrlsEnabled = _.result(appConfig.get('Permissions'), 'IsImpressionTrackingUrlsEnabled');
const isMultiMediaAdsPhase2Enabled = _.result(appConfig.get('Permissions'), 'IsMultiMediaAdsPhase2Enabled');
const isAudienceCampaignMultiMediaAdsEnabled = _.result(appConfig.get('Permissions'), 'IsAudienceCampaignMultiMediaAdsEnabled');
const Permissions = appConfig.get('Permissions');
const isAudienceAssetReportEnabled = _.result(Permissions.dynamic, 'AudienceAssetReport');
const videoTypesWithOrder = [
  'VideoMedia16X9',
  'VideoMedia5X4',
  'VideoMedia1X1',
  'VideoMedia4X5',
  'VideoMedia9X16',
];

export class AdPreviewColumn extends CampaignuiBaseColumn {
  constructor({
    i18n,
    newI18n,
    router,
    scope,
    view,
    permissions,
    serverContext,
    isForVNext,
    deps,
    shouldSendOpportunityLog,
    logOpportunity,
    adsTabPerfMarker,
    preferenceService,
    loadClipchampPlayer,
  }) {
    const title = i18n.getString('ColumnName_Ad');
    const config = {
      ...AdPreviewColumnConfig,
      title,
      editable: true,
      enableEdit: (item) => {
        if (item.Type === 'ResponsiveSearch') {
          return true;
        }
        if (item.Type === 'Responsive' && item.Campaign.CampaignType === 'Default') {
          if (this.isPlaceholderMMA(item)) {
            // not allow editing for the placeholder MMA
            return false;
          }
          return isForVNext && _.result(appConfig.get('Permissions'), 'IsMultiMediaAdsEnabled');
        }
        if (item.Type === 'Responsive' && item.Campaign.CampaignSubType === 'AudienceVideoAds') {
          return true;
        }
        if (item.Type === 'Responsive' && isXandrCampaign(item.Campaign.CampaignSubType)) {
          return true;
        }
        if (item.Type === 'ExpandedText' &&
          !_.result(appConfig.get('Permissions'), 'IsWhiteListEXTAEnabled')
        ) {
          return false;
        }
        /* istanbul ignore next */
        return (((item.Type !== 'Responsive') || this.checkLandscapeImageMediaUrl(item) || this.checkAdSubtypeForMultiAdFormat(item))
          && (item.Type !== 'Hotel') && (item.Type !== 'Product') && (item.DeliveryStatus !== 'AdGroupExpired'));
      },
      type: 'string',
      helpId: 'Page_CampaignGrids_AdPreview',
      bodyClasses: 'grid-column-AdPreview',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
      group: 'freezing',
    };

    super(config);

    this.i18n = i18n;
    this.newI18n = newI18n;
    this.router = router;
    this.scope = scope;
    this.view = view;
    this.permissions = permissions;
    this.isForVNext = isForVNext;
    this.serverContext = serverContext;
    this.preferenceService = preferenceService;
    this.deps = deps;
    this.shouldSendOpportunityLog = shouldSendOpportunityLog;
    this.logOpportunity = logOpportunity;
    this.adsTabPerfMarker = adsTabPerfMarker;
    this.dynamicPermissions = appConfig.get('Permissions').dynamic;
    this.loadClipchampPlayer = loadClipchampPlayer;
  }

  /* istanbul ignore next */
  isVideoAdUnderNative(item) {
    return item && item.Campaign.CampaignSubType === 'AudienceStatic' && item.AdSubType === 'Video';
  }

  /* istanbul ignore next */
  isDisplayAdUnderNative(item) {
    return item && item.Campaign.CampaignSubType === 'AudienceStatic' && item.AdSubType === 'Display';
  }

  isPlaceholderMMA(item) {
    /* istanbul ignore next */
    if (this.dynamicPermissions && this.dynamicPermissions.MultiAdFormat && (this.isVideoAdUnderNative(item) || this.isDisplayAdUnderNative(item))) {
      // Check subtype, video and display will return false, currently use no headline with images or video to determine display ad or video ad
      return false;
    } else if (_.isEmpty(item.Headline) && _.isEmpty(item.Headlines) &&
      _.isEmpty(item.LongHeadline) && _.isEmpty(item.LongHeadlines) &&
      _.isEmpty(item.Text) && _.isEmpty(item.Descriptions) &&
      !isXandrCampaign(item.Campaign.CampaignSubType)) {
      // placeholder MMA under the dynamic ad group
      return true;
    }
    return false;
  }

  checkLandscapeImageMediaUrl(item) {
    /* istanbul ignore next */
    if (this.permissions && this.permissions.IsMMAV2Enabled && _.isArray(item.Images) && _.some(item.Images, image =>
      ((image.Asset.SubType === 'OriginalImage')))) {
      return true;
    }
    return item.LandscapeImageMediaUrl !== null;
  }

  /* istanbul ignore next */
  checkAdSubtypeForMultiAdFormat(item) {
    if (this.dynamicPermissions && this.dynamicPermissions.MultiAdFormat && (this.isDisplayAdUnderNative(item) || this.isVideoAdUnderNative(item))) {
      return true;
    }

    // check item ad subtype for multi ad format
    return false;
  }

  pickProperty(item) {
    const type = item.Type;

    if (item.$total) return { $total: item.$total };
    const urlRegex = new RegExp('http:\/\/|https:\/\/|\{param', 'i'); // eslint-disable-line  no-useless-escape

    let destinationUrl = item.DestinationUrl;
    // add http for destinatioUrl that did not have them.
    if (destinationUrl && destinationUrl.search(urlRegex) === -1) {
      destinationUrl = `http://${destinationUrl}`;
    }

    let result = {
      Type: type,
      Title: item.Title,
      convertedFinalUrl: _.first(item.FinalUrls) || destinationUrl || '',
      Text: item.Text,
      i18n: this.i18n,
      isMultimediaAd: item.Type === 'Responsive' && item.Campaign.CampaignType === 'Default',
      isMultimediaAdinMSANEnabled: isAudienceCampaignMultiMediaAdsEnabled &&
        item.Type === 'Responsive' &&
        (item.Campaign.CampaignType === 'Audience' || item.Campaign.CampaignType === 8),
      isLinkedInAd: item.Type === 'LinkedIn' && (item.Campaign.CampaignType === 'LinkedIn' || item.Campaign.CampaignType === 256),
      campaignSubType: item.Campaign && item.Campaign.CampaignSubType,
      isAudienceAssetReportEnabled,
    };

    if (type === 'Text') {
      result.convertedDisplayUrl = item.DisplayUrl;
      result.computedTitle = item.Title;
    } else if (type === 'Hotel') {
      if (this.dynamicPermissions.IsRenameHotelToLodgingEnabled) {
        result.convertedText = `${this.i18n.getString('AdsSummary_LodgingAdTitle')}`;
      } else {
        result.convertedText = `${this.i18n.getString('AdsSummary_HotelAdTitle')}`;
      }
    } else if (type === 'Product') {
      result.convertedText = item.PromotionalText && item.PromotionalText.length > 0
        ? `${this.i18n.getString('AdsSummary_ProductAdTitle').replace('{0}', ': ')}${item.PromotionalText}`
        : `${this.i18n.getString('AdsSummary_ProductAdTitle').replace('{0}', '')}`;
    } else if (type === 'AppInstall') {
      result.platformText = '';
      if (item.AppPlatform) {
        const appStoreName = this.i18n.getString(`AppStore_${item.AppPlatform.replace(' ', '_')}`);

        result.platformText = this.i18n.getString('Ad_Preview_AppStore').replace('{0}', appStoreName);
      }
    } else if (type === 'DynamicSearch') {
      result.convertedTitle = `{${this.i18n.getString('Ad_DSA_Title')}}`;

      if (item.TextPart2) {
        result.Text = combineText(item.Text, item.TextPart2);
      }

      result.convertedDisplayUrl =
        adDisplayUrlService.getDynamicSearchAdDisplayUrl(item.DisplayUrl, item.Path1, item.Path2);
    } else if (type === 'ExpandedText') {
      const IsExpandedTextAdV2Enabled = _.result(appConfig.get('Permissions'), 'IsExpandedTextAdV2Enabled');

      result.convertedTitle = `${item.TitlePart1} | ${item.TitlePart2}`;
      if (IsExpandedTextAdV2Enabled) {
        if (item.TitlePart3) {
          result.convertedTitle = `${result.convertedTitle} | ${item.TitlePart3}`;
        }

        if (item.TextPart2) {
          result.Text = combineText(item.Text, item.TextPart2);
        }
      }
      result.convertedDisplayUrl =
        adDisplayUrlService.getExpandedTextAdDisplayUrl(
          result.convertedFinalUrl,
          item.DisplayUrl, item.Path1, item.Path2
        );
    } else if (type === 'LinkedIn') {
      result = _.extend(
        result,
        _.pick(item, 'Headline')
      );

      if (item.Images && item.Images.length > 0) {
        const imageUrlToUse = _.first(item.Images).Asset.ImageUrl;
        result.LandscapeImageMediaUrl = `${imageUrlToUse}${resizeQueryString}`;
      }
    } else if (type === 'Responsive') {
      result.isPlaceholderMMA = this.isPlaceholderMMA(item);

      result = _.extend(
        result,
        _.pick(item, 'Headline', 'LongHeadline', 'BusinessName')
      );

      if ((result.isMultimediaAd && isMultiMediaAdsPhase2Enabled) ||
        result.isMultimediaAdinMSANEnabled) {
        if (!_.isEmpty(item.Headlines)) {
          result.Headline = _.first(item.Headlines).Asset.Text;
        }
        if (!_.isEmpty(item.LongHeadlines)) {
          result.LongHeadline = _.first(item.LongHeadlines).Asset.Text;
        }
        if (!_.isEmpty(item.Descriptions)) {
          result.Text = _.first(item.Descriptions).Asset.Text;
        }

        result.HeadlineCount = _.size(item.Headlines);
        result.LongHeadlineCount = _.size(item.LongHeadlines);
        result.TextCount = _.size(item.Descriptions);
        result.imageCount = _.size(item.Images);
      }

      if (result.isPlaceholderMMA) {
        result.Headline = this.i18n.getString('Ad_Placeholder_MMA_Title');
      }

      if (isImpressionTrackingUrlsEnabled) {
        result = _.extend(
          result,
          _.pick(item, 'ImpressionTrackingUrls')
        );
      }

      if (item.LandscapeImageMediaUrl) {
        let imageUrlToUse = item.LandscapeImageMediaUrl;

        // strip off the resizing from MT as we need a smaller resizing
        const indexOfResizeInfo = imageUrlToUse.indexOf('&w=');
        if (indexOfResizeInfo > 0) {
          imageUrlToUse = imageUrlToUse.substr(0, indexOfResizeInfo);
        }

        result.LandscapeImageMediaUrl = `${imageUrlToUse}${resizeQueryString}`;
        /* istanbul ignore next */
      } else if (item.Campaign.CampaignSubType === 'AudienceVideoAds'
        || item.Campaign.CampaignSubType === 'BrandAwarenessVideoAds'
        || this.isVideoAdUnderNative(item)
      ) {
        result.isVideo = true;
        if (item.Videos &&
          item.Videos.length > 0) {
          for (let i = 0; i < videoTypesWithOrder.length; i += 1) {
            const videoType = videoTypesWithOrder[i];
            const videoWithThumbnail = item.Videos.find(v =>
              v.Asset &&
              v.Asset.ThumbnailUrl &&
              v.Asset.SubType === videoType);
            if (videoWithThumbnail) {
              result.LandscapeImageMediaUrl = videoWithThumbnail.Asset.ThumbnailUrl;
              result.IdString = videoWithThumbnail.Asset.IdString;
              result.isVerticalVideo = videoWithThumbnail.Asset.Height > videoWithThumbnail.Asset.Width;
              break;
            }
          }

          // add special handling for google import video ad
          if (item.Campaign.CampaignSubType === 'BrandAwarenessVideoAds'
            && this.permissions && this.permissions.IsGoogleImportVideoAdsEnabled) {
            result.shouldShowActionNeededForGoogleImprotVideoAd = _.get(item, 'Videos[0].Asset.SourceType') === 'GoogleImported'
              && _.get(item, 'Videos[0].Asset.Status') === 'Failed';
          }
        }
      } else if (item.Images && item.Images.length > 0) {
        // for ad without LandscapeImageMediaUrl, pick the image Url from asset
        const imageUrlToUse = _.first(item.Images).Asset.ImageUrl;
        result.LandscapeImageMediaUrl = `${imageUrlToUse}${resizeQueryString}`;
      }

      if (!result.isPlaceholderMMA) {
        result.convertedDisplayUrl =
          adDisplayUrlService.getExpandedTextAdDisplayUrl(
            result.convertedFinalUrl,
            item.DisplayUrl, item.Path1, item.Path2
          );
      }
    } else if (type === 'ResponsiveSearch') {
      const headlineList = _.map(item.Headlines, i => ({
        Text: i.Asset.Text,
        PinnedField: i.PinnedField,
      }));
      const descriptionList = _.map(item.Descriptions, i => ({
        Text: i.Asset.Text,
        PinnedField: i.PinnedField,
      }));

      result.convertedTitle = getTitlePreview(headlineList);
      result.moreTitleHint = getMoreTitleHint(headlineList, this.i18n);
      result.Text = getDescPreview(descriptionList);
      result.moreTextHint = getMoreDescHint(descriptionList, this.i18n);

      result.convertedDisplayUrl =
        adDisplayUrlService.getExpandedTextAdDisplayUrl(
          result.convertedFinalUrl,
          item.DisplayUrl, item.Path1, item.Path2
        );
    }

    return result;
  }

  template({ value }) {
    const DSAAssetReport = this.permissions.dynamic && this.permissions.dynamic.DSAAssetReport;
    const MMAAssetReport = this.permissions.dynamic && this.permissions.dynamic.MMAAssetReportAccountLevel;
    return adTemplate({
      value, DSAAssetReport, MMAAssetReport,
    });
  }

  navigateToSingleAdEditor({ campaignId, adGroupId, adId }) {
    this.router.navigateToRoute('single_ad', {
      campaign_id: campaignId,
      adgroup_id: adGroupId,
      ad_id: adId,
    });
  }

  onPrompt({ event, item }) {
    if ($(event.target).hasClass('linkToAssets')) {
      // view assets details is already handled by grid

      return;
    }

    const { Campaign: campaign, AdGroup: adgroup, Type: type } = item;
    let campaignId;
    let adGroupId;

    if (this.isForVNext) {
      campaignId = campaign ? campaign.Id : this.scope.campaignId || 0;
      adGroupId = adgroup ? adgroup.Id : this.scope.adGroupId || 0;
    } else {
      campaignId = campaign ? campaign.Id : this.i18n.parseDecimal(this.scope.campaignId || '0');
      adGroupId = adgroup ? adgroup.Id : this.i18n.parseDecimal(this.scope.adGroupId || '0');
    }

    const inlineSuggestionsEnabled =
      type === 'ResponsiveSearch' ?
        this.permissions.IsRSASuggestionCMUIEnabled : false;

    const initializer = this.isForVNext && this.deps
      ? () => getAdEditorInitializerWebpack(
        true,
        this.deps.adEditorDependencies
      )
      : getAdEditorInitializer;

    initializer().then(({ initializeAdEditor }) => {
      initializeAdEditor({
        scope: {
          campaignId,
          adGroupId,
          campaignType: _.result(campaign, 'CampaignType'),
        },
        gridView: this.view,
        newI18n: this.newI18n,
        item,
        isForVNext: this.isForVNext,
        inlineSuggestionsEnabled,
        shouldSendOpportunityLog: this.shouldSendOpportunityLog,
        logOpportunity: this.logOpportunity,
        perfMarker: this.adsTabPerfMarker,
        serverContext: this.serverContext,
        preferenceService: this.preferenceService,
        navigateToSingleAdEditor: this.navigateToSingleAdEditor.bind(this),
        loadClipchampPlayer: this.loadClipchampPlayer,
      });
    });
  }
}
